/**
 * @file 文档页页面顶部tab菜单
 * @author wanzhongyun
 */

import React from 'react';
import {Menu} from 'antd';

import LinkA from '../../../../components/a/LinkA';
import {IDocumentMenuItem} from '../../type';

export interface IDocTopMenuProps {
    topMenuSelectedKeys: string[];
    topMenuList: IDocumentMenuItem[];
}

const DocTopMenu: React.FC<IDocTopMenuProps> = props => {
    const {
        topMenuSelectedKeys,
        topMenuList
    } = props;

    return (
        <Menu
            mode="horizontal"
            className="paddle-doc-page-top-menu"
            selectedKeys={topMenuSelectedKeys}
        >
            {topMenuList.map(menuItem => (
                <Menu.Item key={menuItem.key}>
                    <LinkA to={menuItem.link}>
                        {menuItem.title}
                    </LinkA>
                </Menu.Item>
            ))}
        </Menu>
    );
};

export default DocTopMenu;
